import React, { useState, useEffect } from 'react';
import MarketingAuth from '../auth/MarketingAuth';

const MarketingProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    checkAuthentication();
  }, []);

  const checkAuthentication = () => {
    const authStatus = sessionStorage.getItem('marketingAuthenticated');
    const authTime = sessionStorage.getItem('marketingAuthTime');
    
    if (authStatus === 'true' && authTime) {
      const currentTime = Date.now();
      const authTimestamp = parseInt(authTime);
      
      // Session expires after 8 hours (8 * 60 * 60 * 1000 = 28800000 ms)
      const SESSION_DURATION = 8 * 60 * 60 * 1000;
      
      if (currentTime - authTimestamp < SESSION_DURATION) {
        setIsAuthenticated(true);
      } else {
        // Session expired
        sessionStorage.removeItem('marketingAuthenticated');
        sessionStorage.removeItem('marketingAuthTime');
        setIsAuthenticated(false);
      }
    } else {
      setIsAuthenticated(false);
    }
    
    setIsLoading(false);
  };

  const handleAuthentication = (success) => {
    setIsAuthenticated(success);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-purple-500"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <MarketingAuth onAuthenticate={handleAuthentication} />;
  }

  return (
    <div className="relative">
      {children}
    </div>
  );
};

export default MarketingProtectedRoute;
